function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.25 3.75V17.25C2.25 18.9075 3.5925 20.25 5.25 20.25H18.75C20.4075 20.25 21.75 18.9075 21.75 17.25V9H17.25V3.75H2.25ZM3.75 5.25H15.75V17.25C15.75 17.7975 15.9172 18.3075 16.1722 18.75H5.25C4.35675 18.75 3.75 18.1432 3.75 17.25V5.25ZM5.25 6.75V10.5H14.25V6.75H5.25ZM6.75 8.25H12.75V9H6.75V8.25ZM17.25 10.5H20.25V17.25C20.25 18.1432 19.6432 18.75 18.75 18.75C17.8568 18.75 17.25 18.1432 17.25 17.25V10.5ZM5.25 11.25V12.75H9V11.25H5.25ZM10.5 11.25V12.75H14.25V11.25H10.5ZM5.25 13.5V15H9V13.5H5.25ZM10.5 13.5V15H14.25V13.5H10.5ZM5.25 15.75V17.25H9V15.75H5.25ZM10.5 15.75V17.25H14.25V15.75H10.5Z",
  fill: "#7A7A7A"
});

function SvgNewspaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.7278eb54.svg";
export { ForwardRef as ReactComponent };